/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Law_P2_BoldInputs */

const es_l7_law_p2_bold = /** @type {(inputs: L7_Law_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gestora náutica autorizada`)
};

const gl_l7_law_p2_bold = /** @type {(inputs: L7_Law_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`xestora náutica autorizada`)
};

const en_l7_law_p2_bold = /** @type {(inputs: L7_Law_P2_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`authorised nautical manager`)
};

/**
* | output |
* | --- |
* | "authorised nautical manager" |
*
* @param {L7_Law_P2_BoldInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_law_p2_bold = /** @type {((inputs?: L7_Law_P2_BoldInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Law_P2_BoldInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_law_p2_bold(inputs)
	if (locale === "en") return en_l7_law_p2_bold(inputs)
	return es_l7_law_p2_bold(inputs)
});